module.exports = __webpack_public_path__ + "static/media/ersties-com-1c593582.54bc6931.jpg";